/** Katalog-Zeile im Position-Drawer (8c): Mengen-Stepper (neu -- existiert sonst nirgends im
 *  Code) um defaultQuantity/minQuantity, dann "Übernehmen" fuegt die Zeile mit dieser Menge hinzu. */
import { useState } from "react";
import { money, ohneSternchen } from "./format";
import { Button, Icon } from "./components";
import { AllergenBadges } from "./lmiv";
import type { CatalogItem } from "./types";

export function CatalogPickerRow({ item, onAdd }: { item: CatalogItem; onAdd: (qty: number) => void }) {
  const min = item.minQuantity ?? 0;
  const [qty, setQty] = useState(Math.max(item.defaultQuantity || 1, min || 1));
  const archived = item.archivedAt != null;
  return (
    <div className={`flex items-center gap-2 rounded-lg px-3 py-2 hover:bg-surface-container-high/40 dark:hover:bg-surface-variant/20 ${archived ? "opacity-70" : ""}`}>
      <div className="min-w-0 flex-1">
        <p className="flex items-center gap-1.5 truncate font-body-md text-body-md font-medium text-on-background dark:text-inverse-on-surface">
          <span className="truncate">{ohneSternchen(item.name)}</span>
          {/* Badge-Stil identisch zu `catalog.tsx` (Katalogverwaltung) -- gleiche Bedeutung, gleiche Optik. */}
          {archived && (
            <span className="shrink-0 rounded bg-surface-container-high px-1.5 py-0.5 font-label-md text-[10px] uppercase tracking-wide text-on-surface-variant dark:bg-white/[0.08]">
              Archiviert
            </span>
          )}
        </p>
        <p className="flex flex-wrap items-center gap-2 font-body-sm text-body-sm text-secondary dark:text-secondary-fixed-dim">
          {item.priceNote ?? money(item.priceCents)}
          {/* LMIV: Allergene schon bei der Auswahl aus dem Katalog sichtbar. */}
          {(item.kind === "food" || item.kind === "drink") && (
            <AllergenBadges allergens={item.allergens} checked={item.allergensCheckedAt != null} dietary={item.dietary} />
          )}
        </p>
      </div>
      <div className="flex shrink-0 items-center gap-1">
        <Button type="button" variant="ghost" className="!h-7 !w-7 !p-0" title="Weniger" onClick={() => setQty((q) => Math.max(min || 1, q - 1))}>
          <Icon name="remove" className="text-[16px]" />
        </Button>
        <span className="w-6 text-center font-body-sm text-body-sm text-on-background dark:text-inverse-on-surface">{qty}</span>
        <Button type="button" variant="ghost" className="!h-7 !w-7 !p-0" title="Mehr" onClick={() => setQty((q) => q + 1)}>
          <Icon name="add" className="text-[16px]" />
        </Button>
      </div>
      {/* E2E (Golden Path): Icon-only-Button, accessible name kaeme sonst vom Icon-Ligatur-Text
          ("add_circle") statt vom `title` - testid statt Rollen-Matching auf Verdacht. */}
      <Button type="button" variant="primary" data-testid={`katalog-add-${item.id}`} className="shrink-0 !px-2.5 !py-1.5" title="Übernehmen" onClick={() => onAdd(qty)}>
        <Icon name="add_circle" className="text-[16px]" />
      </Button>
    </div>
  );
}
